import * as React from "react";
const SvgFiRrChartSetTheory = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chart-set-theory_svg__a)">
      <path
        fill="#062147"
        d="M19.912 8.573v-.072a7.91 7.91 0 1 0-15.818 0v.072a7.91 7.91 0 1 0 7.909 13.697 7.91 7.91 0 1 0 7.91-13.697m-7.91 11.271a5.93 5.93 0 0 1-1.929-3.667 7.94 7.94 0 0 0 3.856 0 5.93 5.93 0 0 1-1.926 3.662zm0-5.41a5.9 5.9 0 0 1-1.837-.292 5.94 5.94 0 0 1 1.838-3.137 5.94 5.94 0 0 1 1.838 3.137 5.9 5.9 0 0 1-1.838.291m-3.631-1.246a5.94 5.94 0 0 1-2.16-3.401 5.93 5.93 0 0 1 4.066.143 7.9 7.9 0 0 0-1.906 3.258m5.358-3.263a5.93 5.93 0 0 1 4.067-.143 5.94 5.94 0 0 1-2.16 3.406 7.9 7.9 0 0 0-1.907-3.263m-1.726-7.356a5.94 5.94 0 0 1 5.884 5.182 7.9 7.9 0 0 0-5.884.823 7.9 7.9 0 0 0-5.885-.823 5.94 5.94 0 0 1 5.885-5.182M2.116 15.422c0-1.834.85-3.564 2.3-4.686a7.94 7.94 0 0 0 3.632 4.614v.072a7.88 7.88 0 0 0 2.229 5.497 5.932 5.932 0 0 1-8.16-5.497m13.842 5.932c-.764 0-1.521-.147-2.229-.435a7.88 7.88 0 0 0 2.229-5.497v-.072a7.94 7.94 0 0 0 3.633-4.614 5.932 5.932 0 0 1-3.633 10.618"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chart-set-theory_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChartSetTheory;
